<template>
    <div class="titulo-secao justify-space-between" style="display: flex">
        <div>
            {{titulo}}
            <v-tooltip top v-if="exibirRefresh">
                <a slot="activator" @click="$emit('refresh')" class="az-action-link-icon">
                    <i class="fas fa-sync pl-1" style="color: #636363"></i>
                </a>
                <span>Atualizar</span>
            </v-tooltip>
        </div>
        <v-tooltip top v-if="exibirBotaoLimparSelecao">
            <a slot="activator" @click="$emit('limparSelecao')" class="az-action-link-icon">
                <span>
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path fill="#636363" :d="'M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,' +
                     '2 0 0,0 20,2M20,16H8V4H20V16M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16M18.53,8.06L17.47,7L12.59,11.' +
                      '88L10.47,9.76L9.41,10.82L12.59,14L18.53,8.06Z'"/>
                </svg>
                </span>
            </a>
            <span>Limpar seleção</span>
        </v-tooltip>
        <v-tooltip top v-if="exibirBotaoSelecionarTodos">
            <a slot="activator" @click="$emit('selecionarTodos')" class="az-action-link-icon">
                <span>
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path fill="#636363" :d="'M20,16V4H8V16H20M22,16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.' +
                     '89 6.89,2 8,2H20A2,2 0 0,1 22,4V16M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16Z'"/>
                </svg>
                </span>
            </a>
            <span>Selecionar tudo</span>
        </v-tooltip>
    </div>
</template>

<script>
export default {
    name: 'FilaRequisicoesTituloSecao',
    props: {
        titulo: {
            required: true,
            type: String
        },
        exibirRefresh:{
            type: Boolean,
            default: false
        },
        exibirBotaoLimparSelecao:{
            type: Boolean,
            default: false
        },
        exibirBotaoSelecionarTodos:{
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped lang="stylus">
    .titulo-secao
        padding 10px 20px 0
        color var(--v-primary-base)
        font-weight bold
        font-size 14px

    .icone-svg
        fill: currentColor
</style>
